import React from 'react'
import PropTypes from 'prop-types'

import { Grid, Header, Segment } from 'semantic-ui-react'
import { compose } from 'recompose'
import moment from 'moment'

import Enhancer from './DebugModuleEnhancer'
import StandardError from 'Components/StandardError'
import StandardLoader from 'Components/StandardLoader'
import { withPermissions } from 'Components/Permissions'

import Button from 'Components/StandardButton'
import DebugFeed from 'Components/DebugFeed'
import PageHeaderRow from 'Components/PageHeaderRow'

import { startManualUpdate } from 'Global/Helpers/apiHelpers'

const DebugModule = ({ updateLogEvents, updateLogNewestEvent }) => {
  return (
    <Grid>
      <PageHeaderRow title="Debug" />

      <Grid.Row columns={1}>
        <Grid.Column width={8}>
          <Segment>
            <Header as="h2">Updates</Header>
            <Header as="h3">
              Last successful update: <em>{updateLogNewestEvent ? moment(updateLogNewestEvent.updatedAt).fromNow() : 'never'}</em>.
            </Header>
            <Button icon="refresh" onClick={startManualUpdate}>
              Trigger Manual Update
            </Button>
            <DebugFeed events={updateLogEvents} />
          </Segment>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  )
}

DebugModule.propTypes = {
  hasError: PropTypes.bool.isRequired,
  loaderPending: PropTypes.bool.isRequired,
  updateLogEvents: PropTypes.array.isRequired,
  updateLogNewestEvent: PropTypes.object,
}

const composed = compose(
  withPermissions('modules.debug'),
  Enhancer,
  StandardLoader('Loading…'),
  StandardError,
)

export default composed(DebugModule)
